// Utils
import { LinkCreationService } from '@sportal365/smp-widget-utils';

// Constants
import { assetsPlaceholder } from '../../../../../packages/constants/assetsPlaceholder';
import { TARGET_BLANK, TARGET_SELF } from '../../../../../packages/constants/windowTarget';
import { COMPETITION_ENTITY, PLAYER_ENTITY } from '../../../../../packages/constants/entityTypes';

// Types
import { IConfigEntityLinks, IPlayerResponse } from '../../../../../packages/types';

interface INormalizePlayer {
  statistics?: IPlayerResponse;
  dataEntityLinks?: IConfigEntityLinks | null;
}

export const normalizePlayer = ({ statistics, dataEntityLinks }: INormalizePlayer) => {
  const linkService = dataEntityLinks && new LinkCreationService(dataEntityLinks);
  const target = dataEntityLinks?.configuration?.newWindow ? TARGET_BLANK : TARGET_SELF;

  if (!statistics) return;

  return {
    player: {
      id: statistics?.player?.id ?? '',
      name: statistics?.player?.name ?? '',
      image: statistics?.player?.assets?.thumb?.url ?? assetsPlaceholder.player,
      url: linkService?.createEntityUrl(statistics?.player?.id ?? '', PLAYER_ENTITY, '', statistics?.player?.slug) ?? '#',
      target,
    },
    team: {
      id: statistics?.teams && statistics?.teams?.length > 0 ? (statistics?.teams[0].id as string) : '',
      name: statistics?.teams && statistics?.teams?.length > 0 ? statistics?.teams[0].name : '',
      image:
        statistics?.teams && statistics?.teams?.length > 0 ? (statistics.teams[0]?.assets?.logo?.url as string) : assetsPlaceholder.team,
    },
    tournament: {
      id: statistics?.season?.tournament?.id ?? '',
      image: statistics?.season?.tournament?.assets?.logo?.url ?? assetsPlaceholder.tournament,
      title: statistics?.season?.tournament?.name ?? '',
      subTitle: statistics?.season?.name ?? '',
      slug: statistics?.season?.tournament?.slug ?? '',
      url:
        linkService?.createEntityUrl(
          statistics?.season?.tournament?.id ?? '',
          COMPETITION_ENTITY,
          '',
          statistics?.season?.tournament?.slug ?? '',
        ) ?? '#',
      target,
    },
    statistics: statistics.statistics.map(({ value, name }) => ({
      value: Number(value) ?? 0,
      label: name ?? '',
    })),
  };
};
